"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionedExchange__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "orderId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "tokenGive",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "tokenGet",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountGive",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountGet",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "expireDate",
                type: "uint256",
            },
        ],
        name: "ExchangeOrderSent",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "orderId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "tokenGive",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountGive",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "tokenGet",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountGet",
                type: "uint256",
            },
        ],
        name: "OrderSettled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "QuotaAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "orderId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "tokenGive",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountGive",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "tokenGet",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountGet",
                type: "uint256",
            },
        ],
        name: "Trade",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "addQuota",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_orderId",
                type: "uint256",
            },
        ],
        name: "cancelOrder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_tokenGive",
                type: "address",
            },
            {
                internalType: "address",
                name: "_tokenGet",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amountGive",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_amountGet",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_expireDate",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_tokenGiveBalance",
                type: "uint256",
            },
        ],
        name: "createPairOrders",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "exchangeController",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISettings",
                name: "_settings",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "_controllers",
                type: "address[]",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "nextOrderId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "orders",
        outputs: [
            {
                internalType: "address",
                name: "tokenGive",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenGet",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amountGive",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountGet",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "expireDate",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "pairOrderId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "tokenGiveBalance",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_tokenGive",
                type: "address",
            },
            {
                internalType: "address",
                name: "_tokenGet",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amountGive",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_amountGet",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_expireDate",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_pairId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_tokenGiveBalance",
                type: "uint256",
            },
        ],
        name: "sendOrder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_controller",
                type: "address",
            },
            {
                internalType: "bool",
                name: "_isController",
                type: "bool",
            },
        ],
        name: "setController",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settings",
        outputs: [
            {
                internalType: "contract ISettings",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_orderId",
                type: "uint256",
            },
        ],
        name: "settleExpiredOrder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_orderId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "trade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tradeQuota",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class PermissionedExchange__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "PermissionedExchange";
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.PermissionedExchange__factory = PermissionedExchange__factory;
PermissionedExchange__factory.bytecode = _bytecode;
PermissionedExchange__factory.abi = _abi;
